<template>
  <div class="fz-service">
    <div class="col-xs-12">
      <div class="col-sm-1"
           style="width:180px;">
        <img src="@/static/images/logo_home.png"
             style="width:160px;">
      </div>
      <div class="col-xs-9">
        <div class="fz-service-tabs">
          <router-link to="/service"
                       class="fz-service-tab-item active">
            服务网点
          </router-link>
          <router-link to="/service_post"
                       class="fz-service-tab-item ">
            收费细则
          </router-link>
          <router-link to="/service_active"
                       class="fz-service-tab-item">
            活动及优惠
          </router-link>
        </div>
        <div class="fz-service-search mb20">
          <form class="form-inline searchForm"
                id="searchForm"
                action="#"
                method="GET">

            <div class="form-group">
              <input name="_keywords"
                     v-model="searchAddress"
                     id="_keywords"
                     class="form-control input-sm fz-input-radiu"
                     placeholder="输入查询地区">
            </div>

            <div class="form-group">
              <a href="#"
                 class="fz-goto-search"
                 @click="toSearch">
                <i class="fa fa-search"></i>
              </a>
            </div>

          </form>
        </div>
      </div>
    </div>

    <div class="clearfix"></div>
    <div class="fz-service-content">
      <div class="fz-service-content-left">
        <div class="fz-service-item"
             v-for="(item,index) in listData"
             :key="item.key"
             :class="[index===1?'active':'']"
             @click="toCenter(item)">
          <p style="margin-left: 14px;"> {{ item.title }}</p>
          <p style="margin-left: 14px;">Add: {{ item.address }}</p>
          <p style="margin-left: 14px;">Tel: {{ item.tel }}</p>
        </div>
      </div>
      <div class="fz-service-content-right">
        <div id="map"
             ref="map"
             style="  height:calc(100vh - 200px); "></div>
      </div>
    </div>
  </div>
</template>
 
<script>
let echarts = require('echarts/lib/echarts');
require('echarts/lib/chart/bar');  // 引入柱状图组件
require('echarts/lib/chart/pie');  // 引入饼状图组件
require('echarts/map/js/china.js');  // 引入中国地图组件
// 引入提示框和title组件
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');
require('echarts/theme/macarons');//引入主题
require('echarts/theme/shine');//引入主题
// 地图geo
require('echarts/lib/component/geo');
import option from '@/static/js/map-option'
import { req } from "../api/axiosFun"
import BMap from 'BMap'

export default {
  name: 'service',
  data () {
    return {
      loading: false, //是显示加载
      mapData: {
        lat: 113.918422,
        long: 22.672119,
      },
      searchAddress: '',
      map: null,
      listData: []
    }
  },
  components: {

  },
  created () {

  },

  mounted () {

    this.requestData();
  },
  updated () {

  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    toSearch () {
      this.requestData();
    },
    async requestData () {
      try {
        const res = await this.$api.get('/service?q=' + this.searchAddress);
        this.listData = res.data;
        console.log(this.listData)
        this.currentList = res.data;
        this.$parent.isLoading = false;
        this.createMap();
      } catch (e) {
        this.$toast.open({
          message: '获取产品信息失败!',
          type: 'error',
          position: 'top'
        });
      }
    },
    toCenter (value) {
      let arr = value.lat.split(',');
      if (arr[1]) {
        var pt = new BMap.Point(arr[0], arr[1]);
        this.map.centerAndZoom(pt, 12);
      }
    },
    createMap () {
      /* eslint-disable */

      // 创建Map实例
      this.map = new BMap.Map("map")
      // 初始化地图,设置中心点坐标和地图级别
      this.map.centerAndZoom(new BMap.Point(this.mapData.lat, this.mapData.long), 2)
      //添加地图类型控件
      this.map.addControl(new BMap.MapTypeControl({
        mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP]
      }))
      this.listData.map(value => {
        let arr = value.lat.split(',');
        if (arr[1]) {
          var pt = new BMap.Point(arr[0], arr[1]);
          var myIcon = new BMap.Icon(require('../static/images/point.png'), new BMap.Size(52, 32));
          var marker = new BMap.Marker(pt, { icon: myIcon });  // 创建标注
          this.map.addOverlay(marker);
        }

      })

      // 设置地图显示的城市 此项是必须设置的
      this.map.setCurrentCity("深圳")
      //开启鼠标滚轮缩放
      this.map.enableScrollWheelZoom(true)
      /* eslint-enable */
    },

  },
}
</script>

<style lang="scss" scoped>
.fz-service {
  padding: 20px;
}
.fz-service-tabs,
.fz-service-content {
  display: flex;
  margin-bottom: 15px;
}
.fz-service-tab-item {
  color: #fff;
  padding: 3px 10px;
  border-radius: 3px;
  font-size: 12px;
  margin-right: 20px;
}
.fz-service-tabs .active {
  background-color: #ff9800 !important;
}
.fz-service-content {
  min-height: 400px;
}
.fz-service-content-left {
  width: 30%;
  background-color: #fff;
  margin-right: 10px;
  padding: 15px;
  font-size: 12px;
}
.fz-service-content-right {
  width: 69%;
  background-color: #fff;
}
.fz-service-item {
  padding: 8px 0px;
  border-bottom: 1px solid #c8c6c6;
  cursor: pointer;
}
.fz-service-item p {
  margin-bottom: 0px !important;
}
</style>